/**
 * Created by Rumyantsev Daniil on 25.09.2018.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Переводит число байт в мегабайты
 *
 * Usage:
 *   value | toMBytes
 */
@Pipe({name: 'toMBytes'})
export class BytesToMBytesPipe implements PipeTransform {

  readonly BYTES_TO_MB = 1/(1024 * 1024);

  transform(sizeInBytes: number): string  {

    if(sizeInBytes == null ) { return null;}

    return (sizeInBytes * this.BYTES_TO_MB).toFixed(4) + ' МБ';

  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/bytes-to-mbytes.pipe.ts